<template>
    <div>
        <div class="tv-nav">
            <div class="logo">
                <img :src="logo" @click="toHome()"/>
            </div>
        </div>
        <div class="about-app-inset">
            <image-bg 
                :title="'About the App'" 
                :min-title="'アプリについて'"
                :bg-images="banner"
            ></image-bg>
            <div class="msg-area">
                本アプリは海外から日本の地上波、BS、CS計48chが視聴できるアプリです。<br/>
                インターネットさえあれば、時間も場所も端末も選びません。好きなタイミングで過去4週間分の番組を遡って視聴でき、Androidや、FireTV Stick、Google Play端末など多くのデバイスに対応しております。他にも月間人気オンラインビデオや大画面TVにミラーリングする機能なども搭載。あなたの海外生活がより快適でより贅沢なものになるアプリです。<br/>
                まずは1週間の無料体験でその快適さをご実感ください。
            </div>
            <tv-footer></tv-footer>
        </div>
    </div>
</template>
<script>
import imageBg from '../../components/image-bg'
import tvFooter from '../home/modules/footer'
import { banner } from './images/index'
import logo from '../../images/logo.png'
import publicMinxin from '../public-minxin'
export default {
    mixins: [publicMinxin],
    components: {
        imageBg,
        tvFooter
    },
    data () {
        return {
            banner,
            logo
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {

        }
    }
}
</script>
<style scoped>
.about-app-inset {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-top: 60px;
}
.msg-area {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 20px;
    font-size: 14px;
    font-family: Kozuka Gothic Pr6N;
    font-weight: normal;
    color: #000000;
}
.tv-nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    z-index: 999;
    border-bottom: solid 2px  #D1D1D1;;
}
.logo img {
    display: block;
    height: 100%;
}
</style>